export function formatarParaMoedaBRL(valor: number): string {
    return !valor ? '' : valor.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }
   
  export function formatarCNPJ(cnpj: string): string {
    const apenasDigitos = cnpj.replace(/\D/g, "");
   
    if (cnpj.length === 18 && /\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}/.test(cnpj)) {
      return cnpj;
    }
   
    if (apenasDigitos.length === 14) {
      return apenasDigitos.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      );
    }
   
    return cnpj;
  }
   
  export function formatarCPF(cpf: string): string {
    const apenasDigitos = cpf.replace(/\D/g, "");
   
    if (cpf.length === 14 && /\d{3}\.\d{3}\.\d{3}\-\d{2}/.test(cpf)) {
      return cpf;
    }
   
    if (apenasDigitos.length === 11) {
      return apenasDigitos.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
        "$1.$2.$3-$4"
      );
    }
   
    return cpf;
  }